import { atom } from 'jotai';
import { CreditsUsageData, getCreditsUsage } from '../../services/creditsUsageService';

/**
 * Credits 用量数据原子
 */
export const creditsUsageDataAtom = atom<CreditsUsageData | null>(null);

/**
 * Credits 用量加载状态原子
 */
export const creditsUsageLoadingAtom = atom<boolean>(false);

/**
 * Credits 用量错误状态原子
 */
export const creditsUsageErrorAtom = atom<string | null>(null);

/**
 * 获取 Credits 用量的原子
 */
export const fetchCreditsUsageAtom = atom(
  null,
  async (get, set) => {
    try {
      set(creditsUsageLoadingAtom, true);
      set(creditsUsageErrorAtom, null);
      
      const data = await getCreditsUsage();
      set(creditsUsageDataAtom, data);
      
      return data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : '获取用量失败';
      set(creditsUsageErrorAtom, errorMessage);
      throw error;
    } finally {
      set(creditsUsageLoadingAtom, false);
    }
  }
);
